
document.addEventListener("DOMContentLoaded", function () {

    // --- Cookie helpers ---
  const Cookie = {
    get(name) {
      return document.cookie
        .split("; ")
        .find(row => row.startsWith(name + "="))
        ?.split("=")[1] || null;
    },
 
    setSession(name, value, { path = "/", sameSite = "Lax", domain } = {}) {
      let cookie = `${name}=${value}; path=${path}; SameSite=${sameSite}`;
      if (domain) cookie += `; domain=${domain}`;
      document.cookie = cookie;
    },
    del(name, { path = "/", domain } = {}) {
      let cookie = `${name}=; path=${path}; Max-Age=0; SameSite=Lax`;
      if (domain) cookie += `; domain=${domain}`;
      document.cookie = cookie;
    }
  };


  const COOKIE_DOMAIN = undefined; 
////////////////////////////////////////////////////////////////////////////
  const productPage = document.querySelector("[data-should-show-price]");
  const shouldShowPrice = productPage?.dataset.shouldShowPrice === "true";
  // const hasQuoted = localStorage.getItem("hasQuoted") === "true";
  // const hasQuoted = sessionStorage.getItem("hasQuoted") === "true";
    const hasQuoted = Cookie.get("hasQuoted") === "true";

  const quoteButtonWrapper = document.getElementById("quote-button-wrapper");
  const buyButtonWrapper = document.getElementById("buy-button-wrapper");
  const klaviyoRequestQuoteBtn = document.getElementById(
    "klaviyo-request-quote-btn"
  );

  const productUrl = klaviyoRequestQuoteBtn?.dataset.productUrl;
  const productName = klaviyoRequestQuoteBtn?.dataset.productName;

  // Price visibility control
  if (!shouldShowPrice && !hasQuoted) {
    quoteButtonWrapper?.style?.setProperty("display", "block");
    buyButtonWrapper?.style?.setProperty("display", "none");
  } else {
    quoteButtonWrapper?.style?.setProperty("display", "none");
    buyButtonWrapper?.style?.setProperty("display", "block");
    document
      .getElementById("product-price")
      ?.style?.setProperty("display", "block");
    document
      .getElementById("zip-product-widget")
      ?.style?.setProperty("display", "block");
    document
      .querySelector(
        '[id$="__afterpay_on_site_messaging_payments_messaging_KEFtHD"]'
      )
      ?.style?.setProperty("display", "block");
  }

  if (!klaviyoRequestQuoteBtn) return;

  // Open Klaviyo form
  document
    .querySelector(".klaviyo_form_trigger")
    ?.addEventListener("click", function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "Rt3gAJ"]);
    });

  // Wait for Klaviyo form to load using MutationObserver
  const observer = new MutationObserver(() => {
    const klaviyoForm = document.querySelector(
      'form[data-testid="klaviyo-form-Rt3gAJ"]'
    );
    if (klaviyoForm && !window.__klaviyoFormBound) {
      window.__klaviyoFormBound = true;
      observer.disconnect();

      // Listen for Klaviyo form submit
      klaviyoForm.addEventListener("submit", function () {
        console.log("Form submitted");
        // localStorage.setItem("hasQuoted", "true");
        // sessionStorage.setItem("hasQuoted", "true");
                Cookie.setSession("hasQuoted", "true", { domain: COOKIE_DOMAIN });

        const email = document
          .querySelector('input[name="email"]')
          ?.value?.trim();
        const firstName = document
          .querySelector('input[autocomplete="given-name"]')
          ?.value?.trim();
        const lastName = document
          .querySelector('input[autocomplete="family-name"]')
          ?.value?.trim();

        // Debug
        console.log("Submitted:", email, firstName, lastName);

        //Clear _kla_id. This is where Klaviyo save user's info
        //If you don't emial will likely be sent to the previous user.
        document.cookie =
          "_kla_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" +
          window.location.hostname;

        //Probably don't need these below
        localStorage.removeItem("_kla_id");
        sessionStorage.removeItem("_kla_id");

        if(window.klaviyo){
          // alert('Callback1')
        }

        //Save new user info
        window.klaviyo?.push([
          "identify",
          { $email: email, $first_name: firstName, $last_name: lastName },
        ]);

        //Trigger flow, but have to wait new user info to be saved, so 1s delay.
        setTimeout(() => {
          // alert("Callback");
          window.klaviyo?.push([
            "track",
            "metric_test",
            {
              $email: email,
              $first_name: firstName,
              $last_name: lastName,
              "Product URL": productUrl,
              "Product Name": productName,
            },
          ]);
        }, 1000);

        setTimeout(() => window.location.reload(), 3000);
      });

      // Bind fake submit if needed
      const triggerBtn = klaviyoForm.querySelector('button[type="button"]');
      const hiddenSubmit = klaviyoForm.querySelector('input[type="submit"]');

      if (triggerBtn && hiddenSubmit) {
        triggerBtn.addEventListener("click", function (e) {
          e.preventDefault();
          hiddenSubmit.click();
        });
      }

      console.log("Klaviyo form event bound");
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


/**
document.addEventListener("DOMContentLoaded", function () {

  // --- Cookie helpers ---
  const Cookie = {
    get(name) {
      return document.cookie
        .split("; ")
        .find(row => row.startsWith(name + "="))
        ?.split("=")[1] || null;
    },
 
    setSession(name, value, { path = "/", sameSite = "Lax", domain } = {}) {
      let cookie = `${name}=${value}; path=${path}; SameSite=${sameSite}`;
      if (domain) cookie += `; domain=${domain}`;
      document.cookie = cookie;
    },
    
    del(name, { path = "/", domain } = {}) {
      let cookie = `${name}=; path=${path}; Max-Age=0; SameSite=Lax`;
      if (domain) cookie += `; domain=${domain}`;
      document.cookie = cookie;
    }
  };

  const COOKIE_DOMAIN = undefined; 

  ////////////////////////////////////////////////////////////////////////////
  const productPage = document.querySelector("[data-should-show-price]");
  const shouldShowPrice = productPage?.dataset.shouldShowPrice === "true";
  const hasQuoted = Cookie.get("hasQuoted") === "true";

  const quoteButtonWrapper = document.getElementById("quote-button-wrapper");
  const buyButtonWrapper = document.getElementById("buy-button-wrapper");
  const klaviyoRequestQuoteBtn = document.getElementById("klaviyo-request-quote-btn");

  const productUrl = klaviyoRequestQuoteBtn?.dataset.productUrl;
  const productName = klaviyoRequestQuoteBtn?.dataset.productName;

  // Price visibility control
  if (!shouldShowPrice && !hasQuoted) {
    quoteButtonWrapper?.style?.setProperty("display", "block");
    buyButtonWrapper?.style?.setProperty("display", "none");
  } else {
    quoteButtonWrapper?.style?.setProperty("display", "none");
    buyButtonWrapper?.style?.setProperty("display", "block");
    document.getElementById("product-price")?.style?.setProperty("display", "block");
    document.getElementById("zip-product-widget")?.style?.setProperty("display", "block");
    document.querySelector('[id$="__afterpay_on_site_messaging_payments_messaging_KEFtHD"]')?.style?.setProperty("display", "block");
  }

  if (!klaviyoRequestQuoteBtn) return;

  // Custom fallback modal function
  function showFallbackModal() {
    console.log("Showing fallback modal");
    
    // Create modal HTML
    const modalHTML = `
      <div id="custom-quote-modal" style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999999;
      ">
        <div style="
          background: white;
          padding: 40px;
          border-radius: 8px;
          max-width: 500px;
          width: 90%;
          position: relative;
        ">
          <button id="close-custom-modal" style="
            position: absolute;
            top: 15px;
            right: 15px;
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
            color: #999;
          ">&times;</button>
          
          <h2 style="margin-top: 0; font-family: Poppins, sans-serif;">Complete the form to get a quote for this product</h2>
          <p style="font-family: Poppins, sans-serif;">Register to receive pricing information for this product.</p>
          
          <form id="custom-quote-form" style="margin-top: 20px;">
            <div style="margin-bottom: 15px;">
              <label style="display: block; margin-bottom: 5px; font-family: Poppins, sans-serif;">First Name</label>
              <input type="text" name="firstName" required style="
                width: 100%;
                padding: 10px;
                border: 1px solid #ddd;
                border-radius: 4px;
                font-size: 14px;
                box-sizing: border-box;
                font-family: Poppins, sans-serif;
              ">
            </div>
            
            <div style="margin-bottom: 15px;">
              <label style="display: block; margin-bottom: 5px; font-family: Poppins, sans-serif;">Last name</label>
              <input type="text" name="lastName" required style="
                width: 100%;
                padding: 10px;
                border: 1px solid #ddd;
                border-radius: 4px;
                font-size: 14px;
                box-sizing: border-box;
                font-family: Poppins, sans-serif;
              ">
            </div>

            <div style="margin-bottom: 20px;">
              <label style="display: block; margin-bottom: 5px; font-family: Poppins, sans-serif;">Email</label>
              <input type="email" name="email" required style="
                width: 100%;
                padding: 10px;
                border: 1px solid #ddd;
                border-radius: 4px;
                font-size: 14px;
                box-sizing: border-box;
                font-family: Poppins, sans-serif;
              ">
            </div>
            
            <button type="submit" style="
              width: 100%;
              padding: 12px;
              background: #99ca3d;
              color: white;
              border: none;
              border-radius: 50px;
              font-size: 16px;
              cursor: pointer;
              font-family: Poppins, sans-serif;
              font-weight: bold;
            ">Request Quote</button>
          </form>
          
          <div id="success-message" style="display: none; margin-top: 20px; padding: 15px; background: #d3efcd; border-radius: 4px; color: #1B9500; font-family: Poppins, sans-serif;">
            You're in! We'll send you the pricing information shortly.
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    // Handle close button
    document.getElementById('close-custom-modal').addEventListener('click', () => {
      document.getElementById('custom-quote-modal').remove();
    });
    
    // Handle clicking outside modal
    document.getElementById('custom-quote-modal').addEventListener('click', (e) => {
      if (e.target.id === 'custom-quote-modal') {
        document.getElementById('custom-quote-modal').remove();
      }
    });
    
    // Handle form submission
    document.getElementById('custom-quote-form').addEventListener('submit', function(e) {
      e.preventDefault();
      
      const email = this.querySelector('[name="email"]').value.trim();
      const firstName = this.querySelector('[name="firstName"]').value.trim();
      const lastName = this.querySelector('[name="lastName"]').value.trim();
      
      console.log("Fallback form submitted:", email, firstName, lastName);
      
      // Set cookie
      Cookie.setSession("hasQuoted", "true", { domain: COOKIE_DOMAIN });
      
      // Clear Klaviyo ID
      document.cookie = "_kla_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + window.location.hostname;
      localStorage.removeItem("_kla_id");
      sessionStorage.removeItem("_kla_id");
      
      // Send to Klaviyo
      if (window.klaviyo) {
        try {
          window.klaviyo.push([
            "identify",
            { $email: email, $first_name: firstName, $last_name: lastName }
          ]);
          
          setTimeout(() => {
            window.klaviyo.push([
              "track",
              "metric_test",
              {
                $email: email,
                $first_name: firstName,
                $last_name: lastName,
                "Product URL": productUrl,
                "Product Name": productName
              }
            ]);
          }, 1000);
        } catch (e) {
          console.error("Klaviyo error:", e);
        }
      }
      
      // Show success message
      document.getElementById('custom-quote-form').style.display = 'none';
      document.getElementById('success-message').style.display = 'block';
      
      // Reload page after 3 seconds
      setTimeout(() => window.location.reload(), 3000);
    });
  }

  // Try to open Klaviyo form, fallback to custom modal if it fails
  document.querySelector(".klaviyo_form_trigger")?.addEventListener("click", function () {
    console.log("Request Quote button clicked");
    
    // Try Klaviyo first
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "Rt3gAJ"]);
    console.log("Sent openForm command to Klaviyo");
    
    // Check if form rendered after 1 second
    setTimeout(() => {
      const klaviyoForm = document.querySelector('form[data-testid="klaviyo-form-Rt3gAJ"]');
      if (!klaviyoForm) {
        console.warn("Klaviyo form failed to render, showing fallback modal");
        showFallbackModal();
      } else {
        console.log("✓ Klaviyo form successfully rendered");
      }
    }, 2000);
  });

  // Wait for Klaviyo form to load using MutationObserver
  const observer = new MutationObserver(() => {
    const klaviyoForm = document.querySelector('form[data-testid="klaviyo-form-Rt3gAJ"]');
    
    if (klaviyoForm && !window.__klaviyoFormBound) {
      window.__klaviyoFormBound = true;
      observer.disconnect();
      console.log("✓ Klaviyo form found in DOM and bound");

      // Listen for Klaviyo form submit
      klaviyoForm.addEventListener("submit", function (e) {
        console.log("Klaviyo form submitted");
        
        Cookie.setSession("hasQuoted", "true", { domain: COOKIE_DOMAIN });

        const email = document.querySelector('input[name="email"]')?.value?.trim();
        const firstName = document.querySelector('input[autocomplete="given-name"]')?.value?.trim();
        const lastName = document.querySelector('input[autocomplete="family-name"]')?.value?.trim();

        console.log("Submitted:", email, firstName, lastName);

        // Clear _kla_id cookie
        document.cookie = "_kla_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + window.location.hostname;
        localStorage.removeItem("_kla_id");
        sessionStorage.removeItem("_kla_id");

        // Save new user info
        if (window.klaviyo) {
          try {
            window.klaviyo.push([
              "identify",
              { $email: email, $first_name: firstName, $last_name: lastName }
            ]);
          } catch (e) {
            console.error("Klaviyo identify error:", e);
          }
        }

        // Trigger flow with delay
        setTimeout(() => {
          if (window.klaviyo) {
            try {
              window.klaviyo.push([
                "track",
                "metric_test",
                {
                  $email: email,
                  $first_name: firstName,
                  $last_name: lastName,
                  "Product URL": productUrl,
                  "Product Name": productName
                }
              ]);
            } catch (e) {
              console.error("Klaviyo track error:", e);
            }
          }
        }, 1000);

        setTimeout(() => window.location.reload(), 3000);
      });

      // Bind fake submit button if needed
      const triggerBtn = klaviyoForm.querySelector('button[type="button"]');
      const hiddenSubmit = klaviyoForm.querySelector('input[type="submit"]');

      if (triggerBtn && hiddenSubmit) {
        triggerBtn.addEventListener("click", function (e) {
          e.preventDefault();
          hiddenSubmit.click();
        });
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});*/